const STORAGE_KEY = "mockdb:v1";

const dayMs = 24 * 60 * 60 * 1000;
const TIME_OFFSET_KEY = "mockdb:timeOffsetDays";
const TENANT_KEY = "mockdb:tenantId";
const getTimeOffsetDays = () => {
  try {
    const raw = localStorage.getItem(TIME_OFFSET_KEY);
    return raw ? Number(raw) || 0 : 0;
  } catch {
    return 0;
  }
};
const getActiveTenantId = () => {
  try {
    const raw = localStorage.getItem(TENANT_KEY) || localStorage.getItem("tenantId");
    return raw ? Number(raw) || 1 : 1;
  } catch {
    return 1;
  }
};
const nowMs = () => Date.now() + getTimeOffsetDays() * dayMs;
const nowIso = () => new Date(nowMs()).toISOString();
const daysFromNowIso = (days) => new Date(nowMs() + days * dayMs).toISOString();
const daysAgoIso = (days) => new Date(nowMs() - days * dayMs).toISOString();

const seedTenants = [
  { id: 1, name: "SiweGroup", apps: ["indigent", "lending", "leads"] },
  { id: 2, name: "Indigent Only Municipality", apps: ["indigent"] },
  { id: 3, name: "Lending & Leads Co.", apps: ["lending", "leads"] },
];

const seedUsers = [
  {
    UserID: 1,
    Username: "admin",
    Password: "admin123",
    Email: "admin@example.com",
    FullName: "Admin User",
    RoleId: 5,
    TenantId: 1,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 2,
    Username: "clerk",
    Password: "clerk123",
    Email: "clerk@example.com",
    FullName: "Front Desk Clerk",
    RoleId: 2,
    TenantId: 1,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 3,
    Username: "reviewer",
    Password: "reviewer123",
    Email: "reviewer@example.com",
    FullName: "Review Officer",
    RoleId: 3,
    TenantId: 1,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 4,
    Username: "tenant2admin",
    Password: "admin123",
    Email: "tenant2admin@example.com",
    FullName: "Tenant 2 Admin",
    RoleId: 5,
    TenantId: 2,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 5,
    Username: "tenant2clerk",
    Password: "clerk123",
    Email: "tenant2clerk@example.com",
    FullName: "Tenant 2 Clerk",
    RoleId: 2,
    TenantId: 2,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 6,
    Username: "tenant3admin",
    Password: "admin123",
    Email: "tenant3admin@example.com",
    FullName: "Tenant 3 Admin",
    RoleId: 5,
    TenantId: 3,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 7,
    Username: "tenant3reviewer",
    Password: "reviewer123",
    Email: "tenant3reviewer@example.com",
    FullName: "Tenant 3 Reviewer",
    RoleId: 3,
    TenantId: 3,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: true,
  },
  {
    UserID: 8,
    Username: "inactiveuser",
    Password: "inactive123",
    Email: "inactive@example.com",
    FullName: "Inactive User",
    RoleId: 2,
    TenantId: 1,
    IsActive: false,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 9,
    Username: "lockeduser",
    Password: "locked123",
    Email: "locked@example.com",
    FullName: "Locked User",
    RoleId: 2,
    TenantId: 1,
    IsActive: true,
    FailedLoginAttempts: 5,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 10,
    Username: "tenant3clerk",
    Password: "clerk123",
    Email: "tenant3clerk@example.com",
    FullName: "Tenant 3 Clerk",
    RoleId: 2,
    TenantId: 3,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
  {
    UserID: 11,
    Username: "tenant1viewer",
    Password: "viewer123",
    Email: "tenant1viewer@example.com",
    FullName: "Tenant 1 Viewer",
    RoleId: 4,
    TenantId: 1,
    IsActive: true,
    FailedLoginAttempts: 0,
    LastLoginDate: null,
    PasswordLastChanged: nowIso(),
    RequiresPasswordChange: false,
  },
];

const seedVerifications = Array.from({ length: 12 }, (_, i) => {
  const idx = i + 1;
  return {
    id: idx,
    idNumber: `80010150090${String(idx).padStart(2, "0")}`,
    firstNames: `Person ${idx}`,
    surName: `Sample ${idx}`,
    wardNumber: (idx % 12) + 1,
    idnoMatchStatus: idx % 3 === 0 ? "Not Matched" : "Matched",
    deceasedStatus: idx % 7 === 0 ? "Deceased" : "Alive",
    maritalStatus: idx % 4 === 0 ? "MARRIED" : "SINGLE",
    gender: idx % 2 === 0 ? "Female" : "Male",
    CommercialName1: idx % 5 === 0 ? `Business ${idx}` : "",
  };
});

seedVerifications.push({
  id: 99,
  idNumber: "9999999999999",
  firstNames: "Failed",
  surName: "Verification",
  wardNumber: "N/A",
  idnoMatchStatus: "Not Matched",
  deceasedStatus: "Deceased",
  maritalStatus: "UNKNOWN",
  gender: "Unknown",
  CommercialName1: "",
});

const seedLogs = [
  {
    UserID: 1,
    Username: "admin",
    ResultType: "Success",
    Action: "Login",
    PerformedBy: "system",
    ActionTime: nowIso(),
    Details: "Admin login",
  },
  {
    UserID: 2,
    Username: "clerk",
    ResultType: "Success",
    Action: "LeadCreated",
    PerformedBy: "clerk",
    ActionTime: daysAgoIso(2),
    Details: "Web lead submitted",
  },
  {
    UserID: 3,
    Username: "reviewer",
    ResultType: "Warning",
    Action: "LeadDisqualified",
    PerformedBy: "reviewer",
    ActionTime: daysAgoIso(5),
    Details: "Missing affordability documents",
  },
  {
    UserID: 1,
    Username: "admin",
    ResultType: "Success",
    Action: "InvoicePaid",
    PerformedBy: "system",
    ActionTime: daysAgoIso(1),
    Details: "INV-4003 paid via card",
  },
  {
    UserID: 2,
    Username: "clerk",
    ResultType: "Error",
    Action: "BookingCancelled",
    PerformedBy: "clerk",
    ActionTime: daysAgoIso(7),
    Details: "Client no-show",
  },
  {
    UserID: 6,
    Username: "tenant3admin",
    ResultType: "Success",
    Action: "Login",
    PerformedBy: "system",
    ActionTime: daysAgoIso(3),
    Details: "Tenant 3 admin login",
    tenantId: 3,
  },
];

const seedLeads = [
  {
    id: "LEAD-1001",
    tenantId: 1,
    name: "Lerato Mokoena",
    email: "lerato@example.com",
    phone: "+27 71 555 0101",
    source: "web",
    category: "bankable",
    status: "New",
    createdAt: daysAgoIso(1),
    updatedAt: daysAgoIso(1),
    comments: [],
  },
  {
    id: "LEAD-1002",
    tenantId: 1,
    name: "Sipho Dlamini",
    email: "sipho@example.com",
    phone: "+27 72 555 0199",
    source: "email",
    category: "potential",
    status: "Contacted",
    createdAt: daysAgoIso(3),
    updatedAt: daysAgoIso(2),
    comments: [{ text: "Requested bank statements", at: daysAgoIso(2), by: "clerk" }],
  },
  {
    id: "LEAD-1003",
    tenantId: 1,
    name: "Thandi Ndlovu",
    email: "thandi@example.com",
    phone: "+27 73 555 0142",
    source: "excel",
    category: "bankable",
    status: "Qualified",
    createdAt: daysAgoIso(6),
    updatedAt: daysAgoIso(4),
    comments: [{ text: "Income verified", at: daysAgoIso(4), by: "reviewer" }],
  },
  {
    id: "LEAD-1004",
    tenantId: 1,
    name: "Jabu Khumalo",
    email: "",
    phone: "+27 74 555 0181",
    source: "walk-in",
    category: "potential",
    status: "Disqualified",
    createdAt: daysAgoIso(8),
    updatedAt: daysAgoIso(7),
    comments: [{ text: "Incomplete ID documentation", at: daysAgoIso(7), by: "reviewer" }],
  },
  {
    id: "LEAD-1005",
    tenantId: 1,
    name: "Mpho Naidoo",
    email: "mpho@example.com",
    phone: "+27 79 555 0155",
    source: "web",
    category: "bankable",
    status: "Converted",
    createdAt: daysAgoIso(12),
    updatedAt: daysAgoIso(6),
    comments: [{ text: "Converted to client record", at: daysAgoIso(6), by: "admin" }],
  },
  {
    id: "LEAD-1006",
    tenantId: 1,
    name: "Kamo Seabi",
    email: "kamo@example.com",
    phone: "",
    source: "email",
    category: "potential",
    status: "New",
    createdAt: daysAgoIso(1),
    updatedAt: daysAgoIso(1),
    comments: [],
  },
  {
    id: "LEAD-1007",
    tenantId: 1,
    name: "Neo Jacobs",
    email: "neo@example.com",
    phone: "+27 78 555 0129",
    source: "web",
    category: "bankable",
    status: "Contacted",
    createdAt: daysAgoIso(4),
    updatedAt: daysAgoIso(3),
    comments: [{ text: "Scheduled consultation", at: daysAgoIso(3), by: "clerk" }],
  },
  {
    id: "LEAD-1008",
    tenantId: 1,
    name: "Aisha Patel",
    email: "aisha@example.com",
    phone: "+27 83 555 0170",
    source: "excel",
    category: "potential",
    status: "Qualified",
    createdAt: daysAgoIso(9),
    updatedAt: daysAgoIso(5),
    comments: [{ text: "Scored as medium risk", at: daysAgoIso(5), by: "reviewer" }],
  },
  {
    id: "LEAD-3001",
    tenantId: 3,
    name: "Ethan Clarke",
    email: "ethan@example.com",
    phone: "+27 82 555 0133",
    source: "web",
    category: "bankable",
    status: "New",
    createdAt: daysAgoIso(2),
    updatedAt: daysAgoIso(2),
    comments: [],
  },
  {
    id: "LEAD-3002",
    tenantId: 3,
    name: "Nomsa Dube",
    email: "nomsa@example.com",
    phone: "+27 76 555 0188",
    source: "email",
    category: "potential",
    status: "Contacted",
    createdAt: daysAgoIso(7),
    updatedAt: daysAgoIso(6),
    comments: [{ text: "Awaiting payslips", at: daysAgoIso(6), by: "tenant3reviewer" }],
  },
];

const seedLeadInbox = [
  {
    id: "INBOX-9001",
    tenantId: 1,
    name: "Thabo Maseko",
    email: "thabo@example.com",
    phone: "+27 72 555 0111",
    source: "email",
    category: "potential",
    status: "New",
    receivedAt: daysAgoIso(1),
  },
  {
    id: "INBOX-9002",
    tenantId: 1,
    name: "Grace Sithole",
    email: "grace@example.com",
    phone: "+27 71 222 0190",
    source: "excel",
    category: "potential",
    status: "New",
    receivedAt: daysAgoIso(3),
  },
  {
    id: "INBOX-9003",
    tenantId: 1,
    name: "Front Desk Walk-in",
    email: "",
    phone: "+27 74 333 0112",
    source: "walk-in",
    category: "potential",
    status: "New",
    receivedAt: daysAgoIso(0),
  },
  {
    id: "INBOX-9301",
    tenantId: 3,
    name: "Lebo Moagi",
    email: "lebo@example.com",
    phone: "+27 73 444 0137",
    source: "email",
    category: "potential",
    status: "New",
    receivedAt: daysAgoIso(2),
  },
];

const seedBookings = [
  {
    id: "BOOK-2001",
    tenantId: 1,
    leadId: "LEAD-1001",
    clientName: "Lerato Mokoena",
    service: "Loan Consultation",
    date: daysFromNowIso(7),
    status: "Reserved",
    termsAccepted: true,
    reminders: [],
    notes: [],
  },
  {
    id: "BOOK-2002",
    tenantId: 1,
    leadId: "LEAD-1005",
    clientName: "Mpho Naidoo",
    service: "Disbursement Review",
    date: daysFromNowIso(2),
    status: "Confirmed",
    termsAccepted: true,
    reminders: [],
    notes: [{ text: "Confirmed via SMS", at: daysAgoIso(1), by: "clerk" }],
  },
  {
    id: "BOOK-2003",
    tenantId: 1,
    leadId: "LEAD-1004",
    clientName: "Jabu Khumalo",
    service: "Document Follow-up",
    date: daysAgoIso(4),
    status: "Cancelled",
    termsAccepted: false,
    reminders: [],
    notes: [{ text: "Client no-show", at: daysAgoIso(4), by: "clerk" }],
  },
  {
    id: "BOOK-2004",
    tenantId: 1,
    leadId: "LEAD-1003",
    clientName: "Thandi Ndlovu",
    service: "Final Approval",
    date: daysAgoIso(1),
    status: "Completed",
    termsAccepted: true,
    reminders: [],
    notes: [{ text: "Approved and completed", at: daysAgoIso(1), by: "reviewer" }],
  },
  {
    id: "BOOK-3001",
    tenantId: 3,
    leadId: "LEAD-3001",
    clientName: "Ethan Clarke",
    service: "Loan Consultation",
    date: daysFromNowIso(5),
    status: "Reserved",
    termsAccepted: true,
    reminders: [],
    notes: [],
  },
];

const seedQuotations = [
  {
    id: "QUO-3001",
    tenantId: 1,
    leadId: "LEAD-1001",
    amount: 2500,
    status: "In Progress",
    comments: "",
    createdAt: daysAgoIso(4),
    updatedAt: daysAgoIso(2),
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 250,
  },
  {
    id: "QUO-3002",
    tenantId: 1,
    leadId: "LEAD-1002",
    amount: 1800,
    status: "Expired",
    comments: "Expired after 14 days",
    createdAt: daysAgoIso(18),
    updatedAt: daysAgoIso(4),
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 0,
  },
  {
    id: "QUO-3003",
    tenantId: 1,
    leadId: "LEAD-1003",
    amount: 4200,
    status: "Approved",
    comments: "Approved by committee",
    createdAt: daysAgoIso(10),
    updatedAt: daysAgoIso(8),
    taxRate: 0.15,
    commissionRate: 0.07,
    deposit: 500,
  },
  {
    id: "QUO-3004",
    tenantId: 1,
    leadId: "LEAD-1004",
    amount: 1500,
    status: "Rejected",
    comments: "Affordability declined",
    createdAt: daysAgoIso(12),
    updatedAt: daysAgoIso(11),
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 0,
  },
  {
    id: "QUO-3005",
    tenantId: 3,
    leadId: "LEAD-3001",
    amount: 5200,
    status: "In Progress",
    comments: "",
    createdAt: daysAgoIso(3),
    updatedAt: daysAgoIso(1),
    taxRate: 0.15,
    commissionRate: 0.06,
    deposit: 400,
  },
];

const seedInvoices = [
  {
    id: "INV-4001",
    tenantId: 1,
    quotationId: "QUO-3001",
    bookingId: "BOOK-2001",
    clientName: "Lerato Mokoena",
    amount: 2500,
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 250,
    totalDue: 2500 * 1.15 - 250,
    status: "Unpaid",
    dueDate: daysFromNowIso(10),
    paymentMethod: "card",
    recurring: false,
    paymentLink: "https://pay.example/INV-4001",
    supplierThirdParty: false,
    createdAt: daysAgoIso(1),
  },
  {
    id: "INV-4002",
    tenantId: 1,
    quotationId: "QUO-3002",
    bookingId: null,
    clientName: "Sipho Dlamini",
    amount: 1800,
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 0,
    totalDue: 1800 * 1.15,
    status: "Overdue",
    dueDate: daysAgoIso(3),
    paymentMethod: "debit",
    recurring: true,
    recurringIntervalDays: 30,
    nextInvoiceAt: daysFromNowIso(27),
    paymentLink: "https://pay.example/INV-4002",
    supplierThirdParty: false,
    createdAt: daysAgoIso(20),
  },
  {
    id: "INV-4003",
    tenantId: 1,
    quotationId: "QUO-3003",
    bookingId: "BOOK-2004",
    clientName: "Thandi Ndlovu",
    amount: 4200,
    taxRate: 0.15,
    commissionRate: 0.07,
    deposit: 500,
    totalDue: 4200 * 1.15 - 500,
    status: "Paid",
    dueDate: daysAgoIso(1),
    paymentMethod: "card",
    recurring: false,
    paymentLink: "https://pay.example/INV-4003",
    supplierThirdParty: false,
    createdAt: daysAgoIso(9),
  },
  {
    id: "INV-4004",
    tenantId: 1,
    quotationId: "QUO-3004",
    bookingId: null,
    clientName: "Jabu Khumalo",
    amount: 1500,
    taxRate: 0.15,
    commissionRate: 0.05,
    deposit: 0,
    totalDue: 1500 * 1.15,
    status: "Unpaid",
    dueDate: daysFromNowIso(2),
    paymentMethod: "wallet",
    recurring: false,
    paymentLink: "https://pay.example/INV-4004",
    supplierThirdParty: true,
    createdAt: daysAgoIso(2),
  },
  {
    id: "INV-4301",
    tenantId: 3,
    quotationId: "QUO-3005",
    bookingId: "BOOK-3001",
    clientName: "Ethan Clarke",
    amount: 5200,
    taxRate: 0.15,
    commissionRate: 0.06,
    deposit: 400,
    totalDue: 5200 * 1.15 - 400,
    status: "Unpaid",
    dueDate: daysFromNowIso(8),
    paymentMethod: "card",
    recurring: false,
    paymentLink: "https://pay.example/INV-4301",
    supplierThirdParty: false,
    createdAt: daysAgoIso(1),
  },
];

const seedNotifications = [
  {
    id: "NOTE-5001",
    tenantId: 1,
    type: "booking",
    bookingId: "BOOK-2002",
    message: "Reminder: Mpho Naidoo booking in 3 days",
    dueDate: daysFromNowIso(2),
    createdAt: daysAgoIso(1),
  },
  {
    id: "NOTE-5002",
    tenantId: 1,
    type: "invoice",
    invoiceId: "INV-4004",
    message: "Invoice due soon: INV-4004",
    dueDate: daysFromNowIso(2),
    createdAt: daysAgoIso(0),
  },
  {
    id: "NOTE-5301",
    tenantId: 3,
    type: "invoice",
    invoiceId: "INV-4301",
    message: "Invoice due soon: INV-4301",
    dueDate: daysFromNowIso(8),
    createdAt: daysAgoIso(1),
  },
];

const seedApplications = [
  {
    id: "APP-1001",
    tenantId: 1,
    status: "Rejected",
    createdAt: daysAgoIso(18),
    applicantName: "Rejected Applicant",
    identityNumber: "8001015009087",
    amount: 3500,
    productType: "lending",
    purpose: "Equipment",
    reason: "Failed affordability checks",
    channel: "SELF",
    documents: {},
    comments: [{ text: "Affordability declined", at: daysAgoIso(17), by: "reviewer" }],
  },
  {
    id: "APP-1002",
    tenantId: 1,
    status: "Approved",
    createdAt: daysAgoIso(9),
    applicantName: "Approved Applicant",
    identityNumber: "8001015009088",
    amount: 5000,
    productType: "lending",
    purpose: "Inventory",
    channel: "SELF",
    documents: {},
    comments: [{ text: "Approved by committee", at: daysAgoIso(8), by: "admin" }],
  },
  {
    id: "APP-1003",
    tenantId: 1,
    status: "Submitted",
    createdAt: daysAgoIso(2),
    applicantName: "Lerato Mokoena",
    identityNumber: "8001015009001",
    amount: 2500,
    productType: "lending",
    purpose: "School fees",
    channel: "FRONT_DESK",
    documents: {},
    comments: [],
  },
  {
    id: "APP-1004",
    tenantId: 1,
    status: "Under Review",
    createdAt: daysAgoIso(5),
    applicantName: "Sipho Dlamini",
    identityNumber: "8001015009002",
    amount: 1800,
    productType: "lending",
    purpose: "Vehicle repair",
    channel: "SELF",
    documents: {},
    comments: [{ text: "Awaiting bank statements", at: daysAgoIso(4), by: "reviewer" }],
  },
  {
    id: "APP-1005",
    tenantId: 1,
    status: "On Hold",
    createdAt: daysAgoIso(12),
    applicantName: "Thandi Ndlovu",
    identityNumber: "8001015009003",
    amount: 4200,
    productType: "lending",
    purpose: "Home repair",
    channel: "SELF",
    documents: {},
    comments: [{ text: "Missing proof of residence", at: daysAgoIso(11), by: "reviewer" }],
  },
  {
    id: "APP-1006",
    tenantId: 1,
    status: "Disbursed",
    createdAt: daysAgoIso(25),
    applicantName: "Mpho Naidoo",
    identityNumber: "8001015009004",
    amount: 6000,
    productType: "lending",
    purpose: "Business expansion",
    channel: "FRONT_DESK",
    documents: {},
    comments: [{ text: "Funds disbursed", at: daysAgoIso(20), by: "admin" }],
  },
  {
    id: "APP-3001",
    tenantId: 3,
    status: "Submitted",
    createdAt: daysAgoIso(3),
    applicantName: "Ethan Clarke",
    identityNumber: "8001015009301",
    amount: 5200,
    productType: "lending",
    purpose: "Working capital",
    channel: "SELF",
    documents: {},
    comments: [],
  },
  {
    id: "APP-3002",
    tenantId: 3,
    status: "Under Review",
    createdAt: daysAgoIso(7),
    applicantName: "Nomsa Dube",
    identityNumber: "8001015009302",
    amount: 2700,
    productType: "lending",
    purpose: "Medical",
    channel: "FRONT_DESK",
    documents: {},
    comments: [{ text: "Verifying income", at: daysAgoIso(6), by: "tenant3reviewer" }],
  },
];

const seedDB = () => ({
  tenants: seedTenants,
  users: seedUsers,
  verifications: seedVerifications,
  applications: seedApplications,
  logs: seedLogs,
  leads: seedLeads,
  inboxLeads: seedLeadInbox,
  bookings: seedBookings,
  quotations: seedQuotations,
  invoices: seedInvoices,
  notifications: seedNotifications,
});

const loadDB = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      const db = seedDB();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
      return db;
    }
    const db = JSON.parse(raw);
    if (!db.tenants) db.tenants = seedTenants;
    if (!db.users) db.users = seedUsers;
    if (!db.applications) db.applications = seedApplications;
    if (!db.leads) db.leads = [];
    if (!db.inboxLeads) db.inboxLeads = seedLeadInbox;
    if (!db.bookings) db.bookings = [];
    if (!db.quotations) db.quotations = [];
    if (!db.invoices) db.invoices = [];
    if (!db.notifications) db.notifications = seedNotifications;
    if (!db.logs) db.logs = [];
    if (!db.applications) db.applications = seedApplications;
    mergeById(db.leads, seedLeads);
    mergeById(db.inboxLeads, seedLeadInbox);
    mergeById(db.bookings, seedBookings);
    mergeById(db.quotations, seedQuotations);
    mergeById(db.invoices, seedInvoices);
    mergeById(db.notifications, seedNotifications);
    mergeById(db.applications, seedApplications);
    db.leads.forEach((l) => { if (!l.tenantId) l.tenantId = 1; });
    db.inboxLeads.forEach((l) => { if (!l.tenantId) l.tenantId = 1; });
    db.bookings.forEach((b) => { if (!b.tenantId) b.tenantId = 1; });
    db.quotations.forEach((q) => { if (!q.tenantId) q.tenantId = 1; });
    db.invoices.forEach((i) => { if (!i.tenantId) i.tenantId = 1; });
    db.notifications.forEach((n) => { if (!n.tenantId) n.tenantId = 1; });
    db.logs.forEach((l) => { if (!l.tenantId) l.tenantId = 1; });
    db.applications.forEach((a) => { if (!a.tenantId) a.tenantId = 1; });
    return db;
  } catch {
    const db = seedDB();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
    return db;
  }
};

const saveDB = (db) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(db));
};

const mergeById = (target, seeds, key = "id") => {
  if (!Array.isArray(target) || !Array.isArray(seeds)) return;
  seeds.forEach((seed) => {
    if (!target.some((item) => item && item[key] === seed[key])) {
      target.push(seed);
    }
  });
};

const ensureBookingReminders = (db) => {
  const activeTenantId = getActiveTenantId();
  const now = nowMs();
  const soon = now + 3 * dayMs;
  db.bookings.filter((b) => b.tenantId === activeTenantId).forEach((booking) => {
    const when = new Date(booking.date).getTime();
    if (!Number.isFinite(when)) return;
    if (when >= now && when <= soon) {
      const exists = db.notifications.some(
        (n) => n.type === "booking" && n.bookingId === booking.id && n.tenantId === activeTenantId
      );
      if (!exists) {
        db.notifications.unshift({
          id: `NOTE-${Date.now()}-${booking.id}`,
          type: "booking",
          bookingId: booking.id,
          tenantId: activeTenantId,
          message: `Reminder: ${booking.clientName} booking in 3 days`,
          dueDate: booking.date,
          createdAt: nowIso(),
        });
        logAction(db, { Action: "AutoReminder", ResultType: "Success", Details: `Booking ${booking.id}` });
      }
    }
  });
};

const ensureInvoiceAutomation = (db) => {
  const activeTenantId = getActiveTenantId();
  const now = nowMs();
  const soon = now + 3 * dayMs;
  db.invoices.filter((i) => i.tenantId === activeTenantId).forEach((inv) => {
    const due = new Date(inv.dueDate).getTime();
    if (Number.isFinite(due)) {
      if (inv.status === "Unpaid" && due < now) {
        inv.status = "Overdue";
      }
      const remindExists = db.notifications.some(
        (n) => n.type === "invoice" && n.invoiceId === inv.id && n.tenantId === activeTenantId
      );
      if (!remindExists && due >= now && due <= soon) {
        db.notifications.unshift({
          id: `NOTE-${Date.now()}-${inv.id}`,
          type: "invoice",
          invoiceId: inv.id,
          tenantId: activeTenantId,
          message: `Invoice ${inv.id} due in 3 days`,
          dueDate: inv.dueDate,
          createdAt: nowIso(),
        });
        logAction(db, { Action: "AutoReminder", ResultType: "Success", Details: `Invoice ${inv.id}` });
      }
    }

    if (inv.recurring) {
      if (!inv.recurringIntervalDays) inv.recurringIntervalDays = 30;
      if (!inv.nextInvoiceAt) {
        const base = Number.isFinite(due) ? due : now;
        inv.nextInvoiceAt = new Date(base + inv.recurringIntervalDays * dayMs).toISOString();
      }
      const nextAt = new Date(inv.nextInvoiceAt).getTime();
      if (Number.isFinite(nextAt) && nextAt <= now) {
        const amount = Number(inv.amount || 0);
        const taxRate = Number(inv.taxRate ?? 0.15);
        const deposit = Number(inv.deposit || 0);
        const newInv = {
          ...inv,
          id: `INV-${Date.now()}`,
          tenantId: activeTenantId,
          status: "Unpaid",
          dueDate: inv.nextInvoiceAt,
          createdAt: nowIso(),
          totalDue: amount * (1 + taxRate) - deposit,
          parentInvoiceId: inv.id,
        };
        db.invoices.unshift(newInv);
        inv.nextInvoiceAt = new Date(nextAt + inv.recurringIntervalDays * dayMs).toISOString();
        logAction(db, { Action: "RecurringInvoice", ResultType: "Success", Details: `${inv.id} -> ${newInv.id}` });
      }

      if (inv.paymentMethod === "debit" && inv.status === "Overdue") {
        inv.status = "Paid";
      }
    }
  });
};

const applyAutomation = (db) => {
  ensureBookingReminders(db);
  ensureInvoiceAutomation(db);
  saveDB(db);
};

const makeToken = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

const matchEndpoint = (url = "") => {
  const u = String(url).toLowerCase();
  if (u.includes("login")) return "login";
  if (u.includes("tenants/list")) return "tenantsList";
  if (u.includes("changepassword")) return "changePassword";
  if (u.includes("registerperson")) return "registerperson";
  if (u.includes("showverifications")) return "showverifications";
  if (u.includes("saveincome")) return "saveincome";
  if (u.includes("getusers")) return "getusers";
  if (u.includes("saveuser")) return "saveuser";
  if (u.includes("applications/list")) return "applicationsList";
  if (u.includes("applications/save")) return "applicationsSave";
  if (u.includes("applications/status")) return "applicationsStatus";
  if (u.includes("applications/comment")) return "applicationsComment";
  if (u.includes("submitapplication")) return "submitapplication";
  if (u.includes("leads/inbox/list")) return "leadsInboxList";
  if (u.includes("leads/list")) return "leadsList";
  if (u.includes("leads/save")) return "leadsSave";
  if (u.includes("leads/status")) return "leadsStatus";
  if (u.includes("leads/comment")) return "leadsComment";
  if (u.includes("leads/convert")) return "leadsConvert";
  if (u.includes("bookings/list")) return "bookingsList";
  if (u.includes("bookings/save")) return "bookingsSave";
  if (u.includes("bookings/status")) return "bookingsStatus";
  if (u.includes("bookings/comment")) return "bookingsComment";
  if (u.includes("quotations/list")) return "quotationsList";
  if (u.includes("quotations/save")) return "quotationsSave";
  if (u.includes("quotations/status")) return "quotationsStatus";
  if (u.includes("invoices/list")) return "invoicesList";
  if (u.includes("invoices/save")) return "invoicesSave";
  if (u.includes("invoices/status")) return "invoicesStatus";
  if (u.includes("notifications/list")) return "notificationsList";
  if (u.includes("notifications/save")) return "notificationsSave";
  if (u.includes("reports/summary")) return "reportsSummary";
  if (u.includes("audit/logs")) return "auditLogs";
  if (u.includes("automation/advance")) return "automationAdvance";
  return "unknown";
};

const logAction = (db, entry) => {
  const tenantId = getActiveTenantId();
  db.logs.unshift({ ActionTime: nowIso(), tenantId, ...entry });
};

export const useMockApi = process.env.REACT_APP_USE_MOCK_API !== "false";

export const mockPost = async (url, body = {}) => {
  const db = loadDB();
  const endpoint = matchEndpoint(url);

  switch (endpoint) {
    case "tenantsList": {
      return { status: 200, data: { tenants: db.tenants || [] } };
    }
    case "login": {
      const username = String(body.username || "").trim().toLowerCase();
      const password = String(body.password || "");
      const tenantId = Number(body.tenantId || body.TenantId || getActiveTenantId());
      const tenant = (db.tenants || []).find((t) => t.id === tenantId) || (db.tenants || [])[0];
      const user = db.users.find((u) => u.Username.toLowerCase() === username);
      if (!user) {
        return { status: 401, data: { ErrorCode: "INVALID_CREDENTIALS" } };
      }
      if (user.FailedLoginAttempts >= 5) {
        return { status: 403, data: { ErrorCode: "ACCOUNT_LOCKED" } };
      }
      if (user.Password !== password) {
        user.FailedLoginAttempts += 1;
        saveDB(db);
        if (user.FailedLoginAttempts >= 5) {
          return { status: 403, data: { ErrorCode: "ACCOUNT_LOCKED" } };
        }
        return { status: 401, data: { ErrorCode: "INVALID_CREDENTIALS" } };
      }
      if (tenant && user.TenantId && user.TenantId !== tenant.id && user.RoleId !== 5) {
        return { status: 403, data: { ErrorCode: "TENANT_ACCESS_DENIED" } };
      }
      if (!user.IsActive) {
        return { status: 403, data: { ErrorCode: "ACCOUNT_INACTIVE" } };
      }
      if (user.RequiresPasswordChange) {
        return { status: 200, data: { ErrorCode: "PASSWORD_CHANGE_REQUIRED" } };
      }
      try {
        if (tenant?.id) localStorage.setItem(TENANT_KEY, String(tenant.id));
      } catch {}
      user.LastLoginDate = nowIso();
      user.FailedLoginAttempts = 0;
      const token = makeToken();
      logAction(db, {
        UserID: user.UserID,
        Username: user.Username,
        ResultType: "Success",
        Action: "Login",
        PerformedBy: user.Username,
        Details: "Mock login",
      });
      saveDB(db);
      return {
        status: 200,
        data: {
          ErrorCode: "SUCCESS",
          token,
          RoleId: user.RoleId,
          Username: user.Username,
          Email: user.Email,
          FullName: user.FullName,
          UserID: user.UserID,
          TenantId: tenant?.id || user.TenantId || 1,
          TenantName: tenant?.name || "Tenant",
          TenantApps: tenant?.apps || ["indigent", "lending", "leads"],
          RequiresPasswordChange: false,
        },
      };
    }
    case "changePassword": {
      const username = String(body.username || "").trim().toLowerCase();
      const newPassword = String(body.newPassword || "");
      const user = db.users.find((u) => u.Username.toLowerCase() === username);
      if (!user) return { status: 404, data: { message: "User not found" } };
      user.Password = newPassword;
      user.RequiresPasswordChange = false;
      user.PasswordLastChanged = nowIso();
      logAction(db, {
        UserID: user.UserID,
        Username: user.Username,
        ResultType: "Success",
        Action: "ChangePassword",
        PerformedBy: user.Username,
        Details: "Mock password change",
      });
      saveDB(db);
      return { status: 200, data: { success: true } };
    }
    case "registerperson": {
      const identityNumber = String(body.identityNumber || body.identitynumber || "").trim();
      if (!identityNumber) return { status: 400, data: { message: "Missing identityNumber" } };
      let record = db.verifications.find((v) => v.idNumber === identityNumber);
      if (!record) {
        record = {
          id: db.verifications.length + 1,
          idNumber: identityNumber,
          firstNames: "New",
          surName: "Applicant",
          wardNumber: 1,
          idnoMatchStatus: "Matched",
          deceasedStatus: "Alive",
          maritalStatus: "SINGLE",
          gender: "Female",
        };
        db.verifications.unshift(record);
      }
      logAction(db, {
        UserID: null,
        Username: body.username || "self",
        ResultType: "Success",
        Action: "RegisterPerson",
        PerformedBy: body.username || "self",
        Details: `Verified ${identityNumber}`,
      });
      saveDB(db);
      return { status: 201, data: { message: "Verification successful", rtv: record } };
    }
    case "showverifications": {
      return { status: 200, data: { rtv: db.verifications } };
    }
    case "saveincome": {
      const key = body.idNumber || body.IDNumber || body.identityNumber || body.PersonId || body.id;
      let record = db.verifications.find((v) => v.idNumber === key || v.id === key);
      if (!record) {
        record = { id: db.verifications.length + 1, idNumber: key || makeToken() };
        db.verifications.unshift(record);
      }
      Object.assign(record, body);
      logAction(db, {
        UserID: null,
        Username: "system",
        ResultType: "Success",
        Action: "SaveIncome",
        PerformedBy: "system",
        Details: `Saved record ${record.idNumber}`,
      });
      saveDB(db);
      return { status: 200, data: { success: true, record } };
    }
    case "getusers": {
      const tenantId = getActiveTenantId();
      return {
        status: 200,
        data: {
          rtv: {
            ResultSets: {
              Table1: db.users.filter((u) => u.TenantId === tenantId).map((u) => ({
                UserID: u.UserID,
                Username: u.Username,
                Email: u.Email,
                FullName: u.FullName,
                IsActive: u.IsActive,
                RoleId: u.RoleId,
                FailedLoginAttempts: u.FailedLoginAttempts,
                LastLoginDate: u.LastLoginDate,
                PasswordLastChanged: u.PasswordLastChanged,
                RequiresPasswordChange: u.RequiresPasswordChange,
              })),
              Table2: db.logs,
            },
          },
        },
      };
    }
    case "saveuser": {
      const incoming = body || {};
      let user = null;
      if (incoming.UserID) {
        user = db.users.find((u) => u.UserID === incoming.UserID);
      }
      if (!user) {
        user = {
          UserID: db.users.length + 1,
          Username: incoming.Username || `user${db.users.length + 1}`,
          Password: incoming.Password || "changeme123",
          Email: incoming.Email || "",
          FullName: incoming.FullName || incoming.Username || "New User",
          RoleId: Number(incoming.RoleId) || 2,
          TenantId: incoming.TenantId || getActiveTenantId(),
          IsActive: incoming.IsActive !== false,
          FailedLoginAttempts: 0,
          LastLoginDate: null,
          PasswordLastChanged: nowIso(),
          RequiresPasswordChange: incoming.RequiresPasswordChange ?? true,
        };
        db.users.push(user);
      } else {
        Object.assign(user, incoming);
      }
      logAction(db, {
        UserID: user.UserID,
        Username: user.Username,
        ResultType: "Success",
        Action: "SaveUser",
        PerformedBy: "admin",
        Details: `Saved ${user.Username}`,
      });
      saveDB(db);
      return { status: 200, data: user };
    }
    case "submitapplication": {
      const appId = `APP-${Date.now()}`;
      const application = {
        id: appId,
        tenantId: Number(body.tenantId || getActiveTenantId()),
        status: "Submitted",
        createdAt: nowIso(),
        ...body,
        comments: [],
      };
      db.applications.unshift(application);
      logAction(db, {
        UserID: null,
        Username: body.applicantName || "self",
        ResultType: "Success",
        Action: "SubmitApplication",
        PerformedBy: body.applicantName || "self",
        Details: `Application ${appId}`,
      });
      saveDB(db);
      return { status: 201, data: { applicationId: appId, status: "submitted" } };
    }
    case "applicationsList": {
      const tenantId = getActiveTenantId();
      return { status: 200, data: { applications: db.applications.filter((a) => a.tenantId === tenantId) } };
    }
    case "applicationsSave": {
      const incoming = body || {};
      let application = null;
      if (incoming.id) application = db.applications.find((a) => a.id === incoming.id);
      if (!application) {
        application = {
          id: incoming.id || `APP-${Date.now()}`,
          tenantId: getActiveTenantId(),
          status: incoming.status || "Submitted",
          createdAt: nowIso(),
          applicantName: incoming.applicantName || "New Applicant",
          identityNumber: incoming.identityNumber || "",
          amount: Number(incoming.amount || 0),
          productType: incoming.productType || "lending",
          purpose: incoming.purpose || "",
          channel: incoming.channel || "FRONT_DESK",
          documents: incoming.documents || {},
          comments: [],
        };
        db.applications.unshift(application);
      } else {
        Object.assign(application, incoming);
      }
      logAction(db, {
        UserID: null,
        Username: "system",
        ResultType: "Success",
        Action: "SaveApplication",
        PerformedBy: "system",
        Details: `Application ${application.id}`,
      });
      saveDB(db);
      return { status: 200, data: { application } };
    }
    case "applicationsStatus": {
      const { id, status } = body || {};
      const application = db.applications.find((a) => a.id === id);
      if (!application) return { status: 404, data: { message: "Application not found" } };
      application.status = status || application.status;
      logAction(db, {
        UserID: null,
        Username: "system",
        ResultType: "Success",
        Action: "UpdateApplicationStatus",
        PerformedBy: "system",
        Details: `${application.id} -> ${application.status}`,
      });
      saveDB(db);
      return { status: 200, data: { application } };
    }
    case "applicationsComment": {
      const { id, text } = body || {};
      const application = db.applications.find((a) => a.id === id);
      if (!application) return { status: 404, data: { message: "Application not found" } };
      if (!application.comments) application.comments = [];
      application.comments.unshift({ text, at: nowIso(), by: "reviewer" });
      logAction(db, {
        UserID: null,
        Username: "reviewer",
        ResultType: "Success",
        Action: "ApplicationComment",
        PerformedBy: "reviewer",
        Details: `${application.id} comment`,
      });
      saveDB(db);
      return { status: 200, data: { application } };
    }
    case "leadsInboxList": {
      const tenantId = getActiveTenantId();
      return { status: 200, data: { inboxLeads: db.inboxLeads.filter((l) => l.tenantId === tenantId) } };
    }
    case "leadsList": {
      const tenantId = getActiveTenantId();
      applyAutomation(db);
      return { status: 200, data: { leads: db.leads.filter((l) => l.tenantId === tenantId) } };
    }
    case "leadsSave": {
      const incoming = body || {};
      let lead = null;
      if (incoming.id) lead = db.leads.find((l) => l.id === incoming.id);
      if (!lead) {
        lead = {
          id: `LEAD-${Date.now()}`,
          tenantId: getActiveTenantId(),
          name: incoming.name || "New Lead",
          email: incoming.email || "",
          phone: incoming.phone || "",
          source: incoming.source || "web",
          category: incoming.category || "potential",
          status: incoming.status || "New",
          createdAt: nowIso(),
          updatedAt: nowIso(),
          comments: [],
        };
        db.leads.unshift(lead);
      } else {
        Object.assign(lead, incoming);
        lead.updatedAt = nowIso();
      }
      logAction(db, {
        UserID: null,
        Username: "system",
        ResultType: "Success",
        Action: "SaveLead",
        PerformedBy: "system",
        Details: `Lead ${lead.id}`,
      });
      saveDB(db);
      return { status: 200, data: lead };
    }
    case "leadsStatus": {
      const { id, status, category } = body || {};
      const lead = db.leads.find((l) => l.id === id);
      if (!lead) return { status: 404, data: { message: "Lead not found" } };
      if (status) lead.status = status;
      if (category) lead.category = category;
      lead.updatedAt = nowIso();
      logAction(db, { Action: "UpdateLeadStatus", ResultType: "Success", Details: `${id} -> ${status || category}` });
      saveDB(db);
      return { status: 200, data: lead };
    }
    case "leadsComment": {
      const { id, text, by } = body || {};
      const lead = db.leads.find((l) => l.id === id);
      if (!lead) return { status: 404, data: { message: "Lead not found" } };
      lead.comments.unshift({ text, at: nowIso(), by: by || "staff" });
      lead.updatedAt = nowIso();
      logAction(db, { Action: "LeadComment", ResultType: "Success", Details: `${id}` });
      saveDB(db);
      return { status: 200, data: lead };
    }
    case "leadsConvert": {
      const { id, booking } = body || {};
      const lead = db.leads.find((l) => l.id === id);
      if (!lead) return { status: 404, data: { message: "Lead not found" } };
      lead.status = "Converted";
      lead.category = "bankable";
      lead.updatedAt = nowIso();
      const newBooking = {
        id: `BOOK-${Date.now()}`,
        tenantId: getActiveTenantId(),
        leadId: lead.id,
        clientName: lead.name,
        service: booking?.service || "Consultation",
        date: booking?.date || nowIso(),
        status: "Reserved",
        termsAccepted: Boolean(booking?.termsAccepted),
        reminders: [],
        notes: [],
      };
      db.bookings.unshift(newBooking);
      logAction(db, { Action: "LeadConvert", ResultType: "Success", Details: `${lead.id} -> ${newBooking.id}` });
      saveDB(db);
      return { status: 200, data: { lead, booking: newBooking } };
    }
    case "bookingsList": {
      const tenantId = getActiveTenantId();
      applyAutomation(db);
      return { status: 200, data: { bookings: db.bookings.filter((b) => b.tenantId === tenantId) } };
    }
    case "bookingsSave": {
      const incoming = body || {};
      let booking = null;
      if (incoming.id) booking = db.bookings.find((b) => b.id === incoming.id);
      if (!booking) {
        booking = {
          id: `BOOK-${Date.now()}`,
          tenantId: getActiveTenantId(),
          leadId: incoming.leadId || null,
          clientName: incoming.clientName || "Client",
          service: incoming.service || "Consultation",
          date: incoming.date || nowIso(),
          status: incoming.status || "Reserved",
          termsAccepted: Boolean(incoming.termsAccepted),
          reminders: [],
          notes: [],
        };
        db.bookings.unshift(booking);
      } else {
        Object.assign(booking, incoming);
      }
      logAction(db, { Action: "SaveBooking", ResultType: "Success", Details: booking.id });
      saveDB(db);
      return { status: 200, data: booking };
    }
    case "bookingsStatus": {
      const { id, status } = body || {};
      const booking = db.bookings.find((b) => b.id === id);
      if (!booking) return { status: 404, data: { message: "Booking not found" } };
      booking.status = status || booking.status;
      logAction(db, { Action: "UpdateBookingStatus", ResultType: "Success", Details: `${id} -> ${status}` });
      saveDB(db);
      return { status: 200, data: booking };
    }
    case "bookingsComment": {
      const { id, text, by } = body || {};
      const booking = db.bookings.find((b) => b.id === id);
      if (!booking) return { status: 404, data: { message: "Booking not found" } };
      booking.notes.unshift({ text, at: nowIso(), by: by || "staff" });
      logAction(db, { Action: "BookingComment", ResultType: "Success", Details: id });
      saveDB(db);
      return { status: 200, data: booking };
    }
    case "quotationsList": {
      const tenantId = getActiveTenantId();
      return { status: 200, data: { quotations: db.quotations.filter((q) => q.tenantId === tenantId) } };
    }
    case "quotationsSave": {
      const incoming = body || {};
      let quote = null;
      if (incoming.id) quote = db.quotations.find((q) => q.id === incoming.id);
      if (!quote) {
        quote = {
          id: `QUO-${Date.now()}`,
          tenantId: getActiveTenantId(),
          leadId: incoming.leadId || null,
          amount: Number(incoming.amount || 0),
          status: incoming.status || "In Progress",
          comments: incoming.comments || "",
          createdAt: nowIso(),
          updatedAt: nowIso(),
          taxRate: Number(incoming.taxRate ?? 0.15),
          commissionRate: Number(incoming.commissionRate ?? 0.05),
          deposit: Number(incoming.deposit || 0),
        };
        db.quotations.unshift(quote);
      } else {
        Object.assign(quote, incoming);
        quote.updatedAt = nowIso();
      }
      logAction(db, { Action: "SaveQuotation", ResultType: "Success", Details: quote.id });
      saveDB(db);
      return { status: 200, data: quote };
    }
    case "quotationsStatus": {
      const { id, status, comments } = body || {};
      const quote = db.quotations.find((q) => q.id === id);
      if (!quote) return { status: 404, data: { message: "Quotation not found" } };
      if (status) quote.status = status;
      if (typeof comments === "string") quote.comments = comments;
      quote.updatedAt = nowIso();
      logAction(db, { Action: "UpdateQuotationStatus", ResultType: "Success", Details: `${id} -> ${status}` });
      saveDB(db);
      return { status: 200, data: quote };
    }
    case "invoicesList": {
      const tenantId = getActiveTenantId();
      applyAutomation(db);
      return { status: 200, data: { invoices: db.invoices.filter((i) => i.tenantId === tenantId) } };
    }
    case "invoicesSave": {
      const incoming = body || {};
      let inv = null;
      if (incoming.id) inv = db.invoices.find((i) => i.id === incoming.id);
      if (!inv) {
        const amount = Number(incoming.amount || 0);
        const taxRate = Number(incoming.taxRate ?? 0.15);
        const deposit = Number(incoming.deposit || 0);
        const recurringIntervalDays = Number(incoming.recurringIntervalDays || 30);
        inv = {
          id: `INV-${Date.now()}`,
          tenantId: getActiveTenantId(),
          quotationId: incoming.quotationId || null,
          bookingId: incoming.bookingId || null,
          clientName: incoming.clientName || "Client",
          amount,
          taxRate,
          commissionRate: Number(incoming.commissionRate ?? 0.05),
          deposit,
          totalDue: amount * (1 + taxRate) - deposit,
          status: incoming.status || "Unpaid",
          dueDate: incoming.dueDate || nowIso(),
          paymentMethod: incoming.paymentMethod || "card",
          recurring: Boolean(incoming.recurring),
          recurringIntervalDays,
          nextInvoiceAt: incoming.recurring
            ? new Date(new Date(incoming.dueDate || nowIso()).getTime() + recurringIntervalDays * dayMs).toISOString()
            : null,
          paymentLink: incoming.paymentLink || `https://pay.example/${Date.now()}`,
          supplierThirdParty: Boolean(incoming.supplierThirdParty),
          createdAt: nowIso(),
        };
        db.invoices.unshift(inv);
      } else {
        Object.assign(inv, incoming);
      }
      logAction(db, { Action: "SaveInvoice", ResultType: "Success", Details: inv.id });
      saveDB(db);
      return { status: 200, data: inv };
    }
    case "invoicesStatus": {
      const { id, status } = body || {};
      const inv = db.invoices.find((i) => i.id === id);
      if (!inv) return { status: 404, data: { message: "Invoice not found" } };
      inv.status = status || inv.status;
      logAction(db, { Action: "UpdateInvoiceStatus", ResultType: "Success", Details: `${id} -> ${status}` });
      saveDB(db);
      return { status: 200, data: inv };
    }
    case "notificationsList": {
      const tenantId = getActiveTenantId();
      applyAutomation(db);
      return { status: 200, data: { notifications: db.notifications.filter((n) => n.tenantId === tenantId) } };
    }
    case "automationAdvance": {
      const days = Number(body.days || 1);
      const current = Number(db.timeOffsetDays ?? getTimeOffsetDays());
      if (days !== 0) {
        db.timeOffsetDays = current + days;
        try {
          localStorage.setItem(TIME_OFFSET_KEY, String(db.timeOffsetDays));
        } catch {}
        logAction(db, {
          Action: "AutomationAdvance",
          ResultType: "Success",
          Details: `Advanced by ${days} days`,
        });
      } else {
        db.timeOffsetDays = current;
      }
      applyAutomation(db);
      saveDB(db);
      return { status: 200, data: { timeOffsetDays: db.timeOffsetDays } };
    }
    case "notificationsSave": {
      const incoming = body || {};
      const note = {
        id: `NOTE-${Date.now()}`,
        type: incoming.type || "reminder",
        message: incoming.message || "Reminder",
        dueDate: incoming.dueDate || nowIso(),
        tenantId: getActiveTenantId(),
        createdAt: nowIso(),
      };
      db.notifications.unshift(note);
      logAction(db, { Action: "SaveNotification", ResultType: "Success", Details: note.id });
      saveDB(db);
      return { status: 200, data: note };
    }
    case "reportsSummary": {
      const tenantId = getActiveTenantId();
      const leads = db.leads.filter((l) => l.tenantId === tenantId);
      const bookingsList = db.bookings.filter((b) => b.tenantId === tenantId);
      const invoicesList = db.invoices.filter((i) => i.tenantId === tenantId);
      const totalLeads = leads.length;
      const bankable = leads.filter((l) => l.category === "bankable").length;
      const potential = leads.filter((l) => l.category === "potential").length;
      const bookings = bookingsList.length;
      const invoices = invoicesList.length;
      const paid = invoicesList.filter((i) => i.status === "Paid").length;
      const overdue = invoicesList.filter((i) => i.status === "Overdue").length;
      return {
        status: 200,
        data: {
          totals: { totalLeads, bankable, potential, bookings, invoices, paid, overdue },
          revenue: invoicesList.reduce((sum, i) => sum + Number(i.totalDue || 0), 0),
        },
      };
    }
    case "auditLogs": {
      const tenantId = getActiveTenantId();
      return { status: 200, data: { logs: db.logs.filter((l) => l.tenantId === tenantId) } };
    }
    default:
      return { status: 404, data: { message: "Unknown endpoint" } };
  }
};
